import { Injectable} from '@angular/core';
import { firebase } from './../tools/tools';
import { UsersModel, User } from './../models/users.model';

@Injectable()
export class UserAuthService{

  private _userModel = new UsersModel();
  users: User[];

  constructor() {
    this.getUsers();
  }

  getUsers(){
    this._userModel.getUsers().subscribe(val => {
      this.users = val; // create the source
    });
  }

  isAdministrador(){
    var user = firebase.auth().currentUser;
    var currentUser: any;
    if(this.users && user){
      currentUser = this._userModel.searchInArray("clave", user.uid, this.users);
    }
    else
      currentUser = "vacio";

    var asw:boolean;

    if(currentUser.rol === 'Administrador' || currentUser.rol === 'Super-Admin')
      asw = true;
    else
      asw = false;

    return asw;
  }

  canEdit(){
    var user = firebase.auth().currentUser;
    var currentUser: any;
    if(this.users && user){
      currentUser = this._userModel.searchInArray("clave", user.uid, this.users);
    }
    else
      currentUser = "vacio";

    var asw:boolean;

    if(currentUser.rol === 'Administrador' || currentUser.rol === 'Editor' || currentUser.rol === 'Super-Admin')
      asw = true;
    else
      asw = false;

    return asw;
  }

  isSuper(){
    var user = firebase.auth().currentUser;
    var currentUser: any;
    if(this.users && user){
      currentUser = this._userModel.searchInArray("clave", user.uid, this.users);
    }
    else
      currentUser = "vacio";

    var asw:boolean;

    if(currentUser.rol === 'Super-Admin')
      asw = true;
    else
      asw = false;

    return asw;
  }
}
